// The values in this mapping will be replaced by the environment variables
// of the running nginx process on startup in a production-like environment.
const productionMapping = {
  VITE_APP_VERSION: "$VITE_APP_VERSION",

  VITE_DATADOG_CONNECTIONSTRING: "$VITE_DATADOG_CONNECTIONSTRING",
  VITE_DATADOG_TAGS: "$VITE_DATADOG_TAGS",

  VITE_AZUREAD_CLIENTID: "$VITE_AZUREAD_CLIENTID",
  VITE_AZUREAD_INSTANCE: "$VITE_AZUREAD_INSTANCE",
  VITE_AZUREAD_DOMAIN: "$VITE_AZUREAD_DOMAIN",
  VITE_AZUREAD_SCOPE: "$VITE_AZUREAD_SCOPE",

  VITE_OPSTEL_API_BASE_URL: "$VITE_OPSTEL_API_BASE_URL",

  VITE_PERSONEEL_ENABLED: "$VITE_PERSONEEL_ENABLED",
  VITE_PERSONEEL_API_BASE_URL: "$VITE_PERSONEEL_API_BASE_URL",

  VITE_DEBUG_SHOW_INFO: "$VITE_DEBUG_SHOW_INFO",

  VITE_FEATURE_FLAGS_ACTION_MUTATION_ENABLED: "$VITE_FEATURE_FLAGS_ACTION_MUTATION_ENABLED",
  VITE_FEATURE_FLAGS_MPS_IMPORT_ENABLED: "$VITE_FEATURE_FLAGS_MPS_IMPORT_ENABLED",
};

// Helper function to get the environment variables either from the
// mapped values on production, or from the current environment on dev.
function getEnvVariable(name: keyof typeof productionMapping): string {
  if (!productionMapping[name].includes("VITE_")) {
    // environment variables were substituted -> running in production
    return productionMapping[name];
  }
  // environment variables not substituted -> running in dev setting
  // use the current environment variables;
  return import.meta.env[name] ?? "";
}

/**
 * Can be used to access the global config directly, however in React components
 * prefer to use the config provided by the context using {@see src/shared/common/contexts/config/useConfig.ts}
 */
export const config = {
  appVersion: getEnvVariable("VITE_APP_VERSION"),
  datadog: {
    connectionString: getEnvVariable("VITE_DATADOG_CONNECTIONSTRING"),
    version: getEnvVariable("VITE_APP_VERSION"),
    tags: getEnvVariable("VITE_DATADOG_TAGS"),
  },
  azureAd: {
    clientId: getEnvVariable("VITE_AZUREAD_CLIENTID"),
    instance: getEnvVariable("VITE_AZUREAD_INSTANCE"),
    domain: getEnvVariable("VITE_AZUREAD_DOMAIN"),
    scope: getEnvVariable("VITE_AZUREAD_SCOPE"),
  },
  opstel: {
    apiBaseUrl: getEnvVariable("VITE_OPSTEL_API_BASE_URL"),
  },
  personeel: {
    enabled: getEnvVariable("VITE_PERSONEEL_ENABLED").toLowerCase() === "true",
    apiBaseUrl: getEnvVariable("VITE_PERSONEEL_API_BASE_URL"),
  },
  debug: {
    showInfo: getEnvVariable("VITE_DEBUG_SHOW_INFO").toLowerCase() === "true",
  },
  featureFlags: {
    isActionMutationEnabled:
      getEnvVariable("VITE_FEATURE_FLAGS_ACTION_MUTATION_ENABLED").toLowerCase() === "true",
    isMpsImportEnabled:
      getEnvVariable("VITE_FEATURE_FLAGS_MPS_IMPORT_ENABLED").toLowerCase() === "true",
  },
};
export type Config = typeof config;
